import cn from 'classnames';
import React from 'react';
import Page, { PageProps } from 'components/Page';
import bem from 'utils/bem';

interface BaseClipSelectPageProps extends PageProps {}

const block = bem('base-clip-select-page');

const BaseClipSelectPage: React.FC<BaseClipSelectPageProps> = ({
  className,
  ...props
}) => {
  return <Page className={cn(block(), className)} {...props} />;
};

export default BaseClipSelectPage;
